// extracted by mini-css-extract-plugin
module.exports = {"VisualSearchContainer":"visualsearch_VisualSearchContainer__9onVb"};